import apis from '../api/apis';
import { instance } from '../api/index';

export default (msg) => {
  if (process.env.NODE_ENV === 'production') {
    msg.location = window.location.href;
    msg.deviceinfo = window.navigator.userAgent;
    const param = {
      msg: encodeURIComponent(JSON.stringify(msg)),
      appname: 'kaijiang',
      platform: 'h5'
    };
    return instance.get(apis.postLog, param);
  }
  return Promise.resolve();
};




// WEBPACK FOOTER //
// ./src/comm/middleware/reportLog.js